import React from 'react';
import '../css/GardenStyleTagStyling.css';

const GardenStyleTag = ({
                 text,
                 type = 'default',
                 size = 'medium',
                 variant = 'filled',
                 icon: Icon,
                 className = '',
                 onClick,
                 ...props
             }) => {
    const tagClasses = [
        'tag',
        `tag--${type}`,
        `tag--${size}`,
        `tag--${variant}`,
        onClick ? 'tag--clickable' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <span
            className={tagClasses}
            onClick={onClick}
            {...props}
        >
      {Icon && <Icon className="tag__icon" />}
            <span className="tag__text">{text}</span>
    </span>
    );
};

export default GardenStyleTag;